import parkRecord from './park-record';
import payRecord from './pay-record';

export default {
  parkRecord,
  payRecord
}


// WEBPACK FOOTER //
// ./src/api/ground-parking/index.js